export const COUNTRY_PREFIX = "@COUNTRY/"
export const FETCH_COUNTRIES = `${COUNTRY_PREFIX}FETCH_COUNTRIES`
